import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'fieldImageRenderImage',
})
export class FieldImageRenderImagePipe implements PipeTransform {

  transform(value: string, imageConfig: string | ((value: string) => string)): string {
    if(typeof imageConfig === 'function') return imageConfig(value)

    return imageConfig
  }

}
